import axiosClient from "./axiosClient";

// Interface for daily users data
export interface DailyUserData {
  date: string;
  users: number;
}

// Interface for country data
export interface CountryData {
  country: string;
  users: number;
}

// Interface for referral stats response
export interface ReferralStats {
  dailyUsersLast7Days: DailyUserData[];
  totalUsers: number;
  usersByCountry: CountryData[];
}

/**
 * Fetch the referral code for the current user
 * @returns {Promise<string>} The referral code
 */
export const getReferralCode = async (): Promise<string> => {
  try {
    const response = await axiosClient.get<string>("/api/analytics/ref");
    return response.data;
  } catch (error) {
    console.error("Error fetching referral code:", error);
    throw error;
  }
};

/**
 * Fetch referral statistics for the current user
 * @returns {Promise<ReferralStats>} The referral statistics
 */
export const getReferralStats = async (): Promise<ReferralStats> => {
  try {
    const response = await axiosClient.get<ReferralStats>(
      "/api/analytics/ref/stats"
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching referral stats:", error);
    throw error;
  }
};
